import 'bootstrap-5';

const BOOTSTRAP_DROPDOWN_KEYS = ['ArrowDown', 'ArrowUp', 'Escape'];
const maskedKeyEvents = new WeakSet();

// Bootstrap's `.dropdown-menu` keydown handler is a document capture listener, and it throws for menus with no
// `data-bs-toggle` toggle (Blueprint, react-bootstrap). This works only because of listener order:
// - this window capture listener runs before Bootstrap's and masks `key` from it, keeping the preventDefault()
//   Bootstrap called so a react-bootstrap modal doesn't also close on the same Escape;
// - the document capture listener below is added after Bootstrap's (it's imported above), so it restores `key`
//   before React and Blueprint see the event.
window.addEventListener('keydown', (event) => {
  const { key, target } = event;
  if (!BOOTSTRAP_DROPDOWN_KEYS.includes(key) || (key !== 'Escape' && /input|textarea/i.test(target.tagName))) return;

  const menu = target.closest?.('.dropdown-menu');
  if (!menu || menu.parentNode.querySelector('[data-bs-toggle="dropdown"]')) return;

  event.preventDefault();
  Object.defineProperty(event, 'key', { configurable: true, value: 'Unidentified' });
  maskedKeyEvents.add(event);
}, true);

document.addEventListener('keydown', (event) => {
  if (maskedKeyEvents.has(event)) delete event.key;
}, true);
